import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import Dialog, { DialogProps } from 'shared/components/Dialog';
import CheckCircleIcon from 'shared/icons/CheckCircle';
import { Description, Title } from './SuccessfullyCreateCaseDialog.style';

type SuccessfullyCreatedCaseDialogProps = {
  title?: string;
  description?: string;
  redirectiButtonLabel?: string;
  onApply: () => void;
} & Pick<DialogProps, 'open' | 'onClose'>;

const SuccessfullyCreatedCaseDialog = ({
  description,
  onApply,
  open,
  redirectiButtonLabel = 'AVAA',
  title,
  onClose,
}: SuccessfullyCreatedCaseDialogProps) => {
  return (
    <Dialog open={open} fullWidth maxWidth="sm" onClose={onClose}>
      <Stack alignItems="center" justifyContent="center" spacing={2.5}>
        <CheckCircleIcon
          sx={{
            color: (theme) => theme.palette.primary.main,
            fontSize: '4rem',
          }}
        />
        {title && <Title>{title}</Title>}
        {description && <Description>{description}</Description>}
        <Button color="success" onClick={onApply}>
          {redirectiButtonLabel}
        </Button>
      </Stack>
    </Dialog>
  );
};

export default SuccessfullyCreatedCaseDialog;
